module.exports = __webpack_public_path__ + "static/media/boy-16.71494d8f.svg";